import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ActionCreators from './../actions';
import DetailsPane from './../components/Conversations/DetailsPane';

function mapDispatchToProps(dispatch) {
  return bindActionCreators(ActionCreators, dispatch);
}

function mapStateToProps(state) {
  return {
    conversations: state.conversations,
    conversationDetails: state.conversationDetails
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(DetailsPane);
